<template>
  <div class="email-right-aside bookmark-tabcontent form theme-form datepicker-responsive">
    <PageValidate ref="OtherContactAndEnquiryDetail">
      <template v-slot:PageBody>
    <div class="card email-body radius-left">
      <div class="">
        <div class="tab-content">
          <div class="tab-pane fade" v-bind:class="'active show'">
            <div class="card">
              <div class="card-header d-flex customStickyCardHeader">
                <h6 class="mb-0" style="align-self: center">
                  {{ $t("lbl_EMPBE_OtherOfficesOrSalesRepresentative") }}
                </h6>
              </div>
              <div class="card-body">
              
                <div class="row">
                  <div class="col-6">
                      <div class="row">
                        <div class="col-12 mb-2 Input_Label">
                          <div class="Input_Label_Left">
                            {{ $t("lbl_EMPBE_CompanyInfo_Contact_Prop_Nature") }} <span class="text-danger">*</span>
                          </div>
                        </div>
                        <div class="col-12">
                          <selection 
                                ControlId="nature" 
                                :title="$t('lbl_EMPBE_PleaseSelect')"
                                 label="Name" 
                                 name="nature"
                                v-model="temp_detailObject.nature" 
                                :options="Temp_NatureOptions" :multiple="false" 
                                :preselect-first="true"
                                :mandatory="$t('lbl_EMPBE_CompanyInfo_Contact_Prop_Nature') + $t('lbl_IsRequire')">
                              </selection>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 MoreDivInLine_16">
                    <div class="MoreDivInLine_Row">
                      <div class="row">
                        <div class="col-12 mb-2 Input_Label">
                          <div class="Input_Label_Left">
                            {{ $t("lbl_EMPBE_CompanyInfoOther_Basic_Headquarter") }} <span class="text-danger">*</span>
                          </div>
                        </div>
                        <div class="col-12">
                          <selection ControlId="countryId" :title="$t('lbl_EMPBE_PleaseSelect')"
                            :mandatory="$t('lbl_EMPBE_CompanyInfoOther_Basic_Headquarter') + $t('lbl_IsRequire')"
                            v-model="temp_detailObject.countryId" label="text" 
                            :options="CountryOptions">
                          </selection>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                 <div class="row">
                  <div class="col-12 MoreDivInLine_16">
                    <div class="MoreDivInLine_Row">
                      <div class="row">
                        <div class="col-12 mb-2 Input_Label">
                          <div class="Input_Label_Left">
                            {{ $t("lbl_EMPBE_CompanyInfo_Basic_CompanyName_En") }} <span class="text-danger">*</span>
                          </div>
                        </div>
                        <div class="col-12">
                          <textbox 
                            ControlId="nameE" 
                            name="nameE" 
                            :title="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_En')"
                            v-model="temp_detailObject.nameE"
                            :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_En')+ $t('lbl_IsRequire')"
                            CharLimit="CheckEnglishChar">
                          </textbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 MoreDivInLine_16">
                    <div class="MoreDivInLine_Row">
                      <div class="row">
                        <div class="col-12 mb-2 Input_Label">
                          <div class="Input_Label_Left">
                            {{ $t("lbl_EMPBE_CompanyInfo_Basic_CompanyName_Cn") }}
                          </div>
                        </div>
                        <div class="col-12">
                          <textbox 
                              ControlId="nameT" 
                              name="nameT" 
                              :title="$t('lbl_EMPBE_CompanyInfo_Basic_CompanyName_Cn')" 
                              v-model="temp_detailObject.nameT">
                            </textbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-12 MoreDivInLine_16">
                    <div class="MoreDivInLine_Row">
                      <div class="row">
                        <div class="col-12 mb-2 Input_Label">
                          <div class="Input_Label_Left">
                            {{ $t("lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_En") }} <span class="text-danger">*</span>
                          </div>
                        </div>
                        <div class="col-12">
                          <textbox 
                              ControlId="addressEng1" 
                              name="addressEng1" 
                              :title="$t('lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_En')" 
                              v-model="temp_detailObject.addressEng1"
                              :mandatory="$t('lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_En') + $t('lbl_IsRequire')" 
                              CharLimit="CheckEnglishChar">
                          </textbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 MoreDivInLine_16">
                    <div class="MoreDivInLine_Row">
                      <div class="row">
                        <div class="col-12 mb-2 Input_Label">
                          <div class="Input_Label_Left">
                            {{ $t("lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_Cn") }}
                          </div>
                        </div>
                        <div class="col-12">  
                            <textbox 
                              ControlId="addressTc1" 
                              name="addressTc1" 
                              :title="$t('lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_Cn')" 
                              v-model="temp_detailObject.addressTC1">
                          </textbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-12">
                    <textbox 
                        ControlId="contactEmail" 
                        :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Email_PlaceOther')"
                        type="email" 
                        v-model="temp_detailObject.contactEmail" 
                        :mandatory="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Email_PlaceOther')+ $t('lbl_IsRequire')">
                        </textbox>
                  </div>
                </div>
                <div style="border: 1px solid #F0F1F2;height: 1px;margin-bottom:25px;"></div> -->

                <!-- <div class="row">
                  <div class="col-12 mb-2 Input_Label">
                  
                    <div class="Input_Label_Left">
                      {{ $t("lbl_EMPBE_CompanyInfo_Contact_Prop_OtherContactInformation") }}
                          </div>
                  </div>
                  <div class="col-12 MoreDivInLine_16">
                    <div class="MoreDivInLine_Row">
                      <div class="row">
                        <div class="col-12 mb-2 Input_Label">
                          <div class="Input_Label_Left">
                          </div>
                        </div>
                        <div class="col-12">
                            <selection 
                                ControlId="contactPhoneCountry" 
                                :title="$t('lbl_EMPBE_CompanyInfo_Contact_Prop_CountryRegionCode')" label="Name"
                                name="contactPhoneCountry" 
                                v-model="temp_detailObject.contactPhoneCountry"
                                :options="Temp_CellCountryOptions" :multiple="false" 
                                :preselect-first="true">
                            </selection>
                        </div>
                      </div>
                    </div>
                    <div class="MoreDivInLine_Row">
                      <div class="row">
                        <div class="col-12 mb-2 Input_Label">
                          <div class="Input_Label_Left">
                          </div>
                        </div>
                        <div class="col-12">
                            <textbox 
                                ControlId="contactPhoneNumber" 
                                :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_MobileNumber')" 
                                type="number"
                                v-model="temp_detailObject.contactPhoneNumber"
                                :class="{ 'is-invalid': temp_detailObject.contactPhoneNumber }">
                            </textbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                      <textbox 
                          ControlId="fax" 
                          :title="$t('lbl_EMPBE_CompanyInfo_Contact_Prop_FaxNumber')" 
                          v-model="temp_detailObject.fax" 
                          type="number"
                          >
                      </textbox>
                  </div>     
                  <div class="col-12">
                    <textbox 
                      ControlId="webSite" 
                      :title="$t('lbl_EMPBE_CompanyInfo_Contact_Prop_Website')"
                      v-model="temp_detailObject.webSite" 
                      type="text">
                    </textbox>
                  </div>            
                </div>
            -->
           

                <div class="customizer-formbutton">
                  <b-button-group>
                    <button type="button" class="btn btn-outline-danger btn-lg" @click="DeleteContact">
                      <i class="icofont icofont-ui-delete m-r-5"></i>{{ $t("lbl_EMPBE_Delete") }}
                    </button>
                    <button type="button" class="btn btn-outline-primary btn-lg" @click="CloseContact">
                      <i class="icofont icofont-ui-check m-r-5"></i>{{ $t("lbl_confirm") }}
                    </button>
                  </b-button-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
</PageValidate>
  </div>
</template>
<script>
export default {
  props: ["detailObject", "detailIndex","NatureOptions","CellCountryOptions","CountryOptions"],
  data() {
    return {
      temp_detailObject: this.detailObject,
      Temp_CellCountryOptions:this.CellCountryOptions,
      Temp_NatureOptions: this.NatureOptions,
    };
  },
  watch: {
    detailObject() {
      this.temp_detailObject = this.detailObject;
      this.resetFormVerify();
    },
    temp_detailObject: {
      handler(newval, oldval) {
        this.updateValue();
      },
      deep: true,
    },
    NatureOptions()
    {
      this.Temp_NatureOptions = this.NatureOptions;
    },
    CellCountryOptions()
    {
      this.Temp_CellCountryOptions = this.CellCountryOptions;
    }
    
  },
  computed: {
    langid() {
      return localStorage.getItem("currentLangId");
    },
  },
  mounted() {
    this.resetFormVerify();
  },
  methods: {
    //重置表单验证
    resetFormVerify()
    {
      this.$refs.OtherContactAndEnquiryDetail.reset();
    },
    updateValue() {
      this.$emit("input", this.temp_detailObject);
    },
     DeleteContact() {
      if (this.detailIndex < 0) {
        if (this.$parent.$parent.$refs.ContactRightpopup.isOpen) {
          this.$root.$emit("bv::toggle::collapse", "ContactRightpopup");
        }
        return;
      }
      this.$parent.$parent.DeleteContact(this.detailIndex);
    },
    CloseContact() {
      this.$refs.OtherContactAndEnquiryDetail
        .validate()
        .then((res) => {
          if (res && res.valid) {
            const list = this.$parent.$parent;
            if (this.detailIndex < 0) {
              var newContact = Object.assign({}, this.temp_detailObject);
              newContact.orderId = list.Temp_Value.length;
              list.Temp_Value.push(newContact);
              list.detailIndex = list.Temp_Value.length - 1;
              list.detailObject = list.Temp_Value[list.detailIndex];
            }
            this.$root.$emit("bv::toggle::collapse", "ContactRightpopup");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.customizer-formbutton
{
  left:0px;
  right: auto;
}
</style>